import React from 'react';
import AOS from 'aos'; // AOS for scroll animations
import 'aos/dist/aos.css'; // AOS styles

const SupportedWallets = () => {
  return (
    <section className="collection-wrap pt-50 pb-50">
      {/* Background Shape Image */}
      <img src={`${process.env.PUBLIC_URL}/assets/img/section-shape-1.png`} alt="Section Shape" className="section-shape" />

      {/* Container for Section Title */}
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-9 text-center">
            <div className="section-title style1 mb-40">
              <h2>Supported Wallets</h2>
            </div>
          </div>
        </div>
      </div>

      {/* Container for Wallets */}
      <div className="container">
        <div className="row justify-content-center">
          {/* Wallet Item 1 */}
          <div className="col-lg-4 col-md-6 text-center">
            <div className="blog-card style1">
              <div className="blog-img">
                <img src={`${process.env.PUBLIC_URL}/assets/img/resources/metamask.jpg`} alt="Metamask Wallet" />
              </div>
            </div>
          </div>

          {/* Wallet Item 2 */}
          <div className="col-lg-4 col-md-6 text-center">
            <div className="blog-card style1">
              <div className="blog-img">
                <img src={`${process.env.PUBLIC_URL}/assets/img/resources/logosample.jpg`} alt="Sample Wallet" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SupportedWallets;
